import { useForm } from '@mantine/form';
import { useEffect, useState } from 'react';
import type { UpsertPromotionDto } from '../types/PromotionDto';
import {
	validateDate,
	validateEndDate,
	validateNumber,
	validateText,
} from '../../../util/validation/commonValidation';

const defaultPromotion: UpsertPromotionDto = {
	branchId: '',
	till: '',
	id: 0,
	days: [],
	qty: '',
	typeId: '',
	discount: '',
	description: '',
};

export function useUpsertPromotionForm(
	promotion: UpsertPromotionDto = defaultPromotion,
) {
	const [inputs, setInputs] = useState<UpsertPromotionDto>(promotion);

	const form = useForm<UpsertPromotionDto>({
		mode: 'uncontrolled',
		initialValues: promotion,
		validate: {
			startDate: (value) => validateDate(value, false),
			endDate: (value, values) =>
				validateEndDate(value, false, values.startDate),
			branchId: (value) =>
				validateNumber(value, false, 0, 10000000, 'Branch', false),
			till: (value) => validateText(value, false, 'Till', 30),
			description: (value) => validateText(value, false, 'Description', 50),
			typeId: (value) =>
				validateNumber(value, false, 0, 10000000, 'Type', false),
			discount: (value) =>
				validateNumber(value, false, 0, 100000000, 'Discount', false),
			qty: (value) =>
				validateNumber(value, false, 0, 100000000, 'Quantity', false),
			days: (value) => {
				if (!value || value.length < 1) {
					return 'Please select at least one day';
				}
			},
		},
		onValuesChange: (v) => setInputs(v),
	});

	return { form, inputs };
}
